export default __webpack_public_path__ + "static/media/featured.5ab39072.png";